import { render, staticRenderFns } from "./destruction.vue?vue&type=template&id=e2a9deb0&"
import script from "./destruction.vue?vue&type=script&lang=js&"
export * from "./destruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports